import { render, staticRenderFns } from "./UnseenMessagesIndicator.vue?vue&type=template&id=8bcd6374"
import script from "./UnseenMessagesIndicator.vue?vue&type=script&lang=js"
export * from "./UnseenMessagesIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports